module.exports = __webpack_public_path__ + "media/images/penny-01829ceed155916376faa2bd8bb7d7a2.svg";